import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  categoryName: string;
  author: string;
  date: string;
  readTime: string;
  imageUrl: string;
  tags: string[];
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  category,
  categoryName,
  author,
  date,
  readTime,
  imageUrl,
}: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300">
      <Link to={`/article/${slug}`} className="block no-underline">
        <div className="aspect-[16/9] overflow-hidden relative bg-background-100">
          <img
            src={imageUrl}
            alt={title}
            title={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      </Link>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-3 mb-3">
          <Link
            to={`/category/${category}`}
            className="text-xs font-medium px-2 py-1 rounded-full bg-primary-100 text-primary-700 hover:bg-primary-200 transition-colors no-underline whitespace-nowrap"
          >
            {categoryName}
          </Link>
          <span className="text-xs text-foreground-400 whitespace-nowrap">{readTime}</span>
        </div>
        <Link to={`/article/${slug}`} className="block no-underline">
          <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
          {excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-400">
          <span>{author}</span>
          <time dateTime={date}>{date}</time>
        </div>
      </div>
    </article>
  );
}